import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getCookie, CookieName } from '@chegg/utils';
import { nrSendError } from './helper';
import { client } from '@chegg/checkout-sdk';

/**
 * captureError function Identifies a browser error without disrupting your app's operations.
 * @param error Error object to log
 * @param meta Additional data to log in New relic
 * use this when you have nr browser defined on your page (cannot be used in standalone react applications)
 */
export var captureError = function captureError(error) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  meta.uuid = getCookie(CookieName.JERICHO_SESSION); //sessionData.user.uuid;
  meta.U = getCookie(CookieName.U);
  meta.exp = getCookie(CookieName.EXPERIMENT);
  nrSendError(error, meta);
};

/**
 * @param error Error message to be logged
 * @param componentName Name of the component
 * @param componentVersion Version of the component
 * @param extras extra information to be logged
 * this can be used for logging errors in standalone react components as well as page level apps.
 * make sure checkoutsdk is initialized before using this.
 */
export var sendCommerceNewRelicError = function sendCommerceNewRelicError(_ref) {
  var _extras$referrer;
  var error = _ref.error,
    componentName = _ref.componentName,
    componentVersion = _ref.componentVersion,
    extras = _ref.extras;
  var newRelicError = _objectSpread({
    component: componentName,
    componentVersion: componentVersion,
    errorMessage: error,
    referrer: (_extras$referrer = extras === null || extras === void 0 ? void 0 : extras.referrer) !== null && _extras$referrer !== void 0 ? _extras$referrer : document.referrer
  }, extras);
  client.newRelic.logError(newRelicError);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/NewRelicUtils/index.js
// module id = 838
// module chunks = 11